import React, { useState } from "react";
import moment from "moment";

const AirportNotamValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!error && !record.notamCode) {
    error = true;
    errorMessage = "NOTAM' is required";
  }

  const fromDate = moment(record.notamFromDate);
  const toDate = moment(record.notamToDate);

  if (!error && (!record.notamFromDate || !fromDate.isValid())) {
    error = true;
    errorMessage = "'Effective From' is required";
  }
  if (!error && !record.notamFromTime) {
    error = true;
    errorMessage = "Effective From 'At Hour' is required";
  }
  if (!error && record.notamFromTime === "00:00") {
    error = true;
    errorMessage = "Please enter a valid Effective At Hour";
  }
  if (!error && (!record.notamToDate || !toDate.isValid())) {
    error = true;
    errorMessage = "'Effective To' is required";
  }
  if (!error && toDate.isBefore(fromDate)) {
    error = true;
    errorMessage = "'Effective To' must be after or equal to 'Arrival Date'";
  }
  if (!error && !record.notamToTime) {
    error = true;
    errorMessage = "Effective To 'At Hour' is required";
  }
  if (!error && record.notamToTime === "00:00") {
    error = true;
    errorMessage = "Please enter a valid Effective To At Hour Time";
  }
  if (!error && record.recurring && (!record.notamDays || record.notamDays == "")) {
    error = true;
    errorMessage = "'Days Effective' should be specified for recurring NOTAMs to define on which days of the week the recurring NOTAM is effective";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default AirportNotamValidator;
